import { ENV, isDevelopment } from "helpers/env";

declare const DIRECT_STAGING_CALL: boolean;
declare const MOCK_JSON: boolean;

const LOGIN_ROUTE: string = "/auth/auth0";
interface IAppConstants {
  HQ_SERVICE: string;
  HQ_WORKFORCE_SERVICE: string;
  LAUNCH_DARKLY_CLIENT_ID: string;
  SEGMENT_KEY: string;
  WORKFORCE: string;
  X_UPSERVE_AUTH_TOKEN: string;
  ANALYTICS_GRAPH: string;
}

interface IConfig {
  test: IAppConstants;
  development: IAppConstants;
  staging: IAppConstants;
  production: IAppConstants;
  [ENV: string]: IAppConstants;
}

const CONFIG: IConfig = {
  test: {
    HQ_SERVICE: "http://localhost:3000",
    HQ_WORKFORCE_SERVICE: "http://localhost:3001",
    LAUNCH_DARKLY_CLIENT_ID: "56932174559981069b000013",
    SEGMENT_KEY: "",
    WORKFORCE: "http://localhost:8081",
    X_UPSERVE_AUTH_TOKEN: "X-Upserve-Auth-Token-Test",
    ANALYTICS_GRAPH: "http://localhost:5000/partners/graph",
  },
  development: {
    HQ_SERVICE: DIRECT_STAGING_CALL
      ? "https://hq-api.staging.upserve.com"
      : "http://localhost:3000",
    HQ_WORKFORCE_SERVICE: DIRECT_STAGING_CALL
      ? "/workforce-api"
      : "http://localhost:3000",
    LAUNCH_DARKLY_CLIENT_ID: "56932174559981069b000013",
    SEGMENT_KEY: "",
    WORKFORCE: "http://localhost:8081",
    X_UPSERVE_AUTH_TOKEN: "X-Upserve-Auth-Token-Development",
    ANALYTICS_GRAPH: "http://localhost:5000/partners/graph",
  },
  staging: {
    HQ_SERVICE: "https://hq-api.staging.upserve.com",
    HQ_WORKFORCE_SERVICE: "https://workforce-api.staging.upserve.com",
    LAUNCH_DARKLY_CLIENT_ID: "56b3645f581f3c06d8000004",
    SEGMENT_KEY: "",
    WORKFORCE: "https://workforce.staging.upserve.com",
    X_UPSERVE_AUTH_TOKEN: "X-Upserve-Auth-Token-Staging",
    ANALYTICS_GRAPH: "https://app.staging.upserve.com/partners/graph",
  },
  production: {
    HQ_SERVICE: "https://hq-api.upserve.com",
    HQ_WORKFORCE_SERVICE: "https://workforce-api.upserve.com",
    LAUNCH_DARKLY_CLIENT_ID: "56932174559981069b000014",
    SEGMENT_KEY: "RxWR2TPUQwSnyMBQGJnwb2mpVQjTgDZK",
    WORKFORCE: "https://workforce.upserve.com",
    X_UPSERVE_AUTH_TOKEN: "X-Upserve-Auth-Token",
    ANALYTICS_GRAPH: "https://app.upserve.com/partners/graph",
  },
};

// Return paths to mock json server when env variable is set
const MOCK_JSON_SERVER = "http://localhost:3004";
function mockPath(livePath: string, mocked: string, force?: boolean) {
  if (!isDevelopment()) {
    return livePath;
  }
  return MOCK_JSON || force ? `${MOCK_JSON_SERVER}${mocked}` : livePath;
}

const TRACK_JS_CONFIG = {
  staging: "workforce-staging",
  production: "workforce-prod",
};

const TRACK_JS_TOKEN = "fd970d226c4b475d897759f950989046";
const TRACK_JS_KEY = TRACK_JS_CONFIG[ENV as keyof typeof TRACK_JS_CONFIG];

export const {
  SEGMENT_KEY,
  HQ_SERVICE,
  LAUNCH_DARKLY_CLIENT_ID,
  WORKFORCE,
  HQ_WORKFORCE_SERVICE,
  X_UPSERVE_AUTH_TOKEN,
  ANALYTICS_GRAPH,
} = CONFIG[ENV];
export { LOGIN_ROUTE, mockPath, TRACK_JS_TOKEN, TRACK_JS_KEY };
